
import { ApplicationState } from '..';
import { CompanyState } from './types';
//export const getCompany = (state: ApplicationState) => state.company.allIds.map( (id:number)=> state.company.byId[id]);
export const getCompany = function getCompany(state:ApplicationState) {
    console.log(state);
    return state.company.allIds.map(function (id:number) {
      return state.company.byId[id];
    });
  };

export const getSelectedCompany = (state: ApplicationState) => state.company.byId[state.company.ui.selected];

export const getEditingCompany = (state: ApplicationState) => state.company.editingById;//[state.company.ui.selected];
//export const getCompanyById = (state: CompanyState) => state.data.filter(f=>{f.id == });